import { render, staticRenderFns } from "./DiscountNewCredentialsCardSingleOrJoint.vue?vue&type=template&id=35c70e04&scoped=true&"
import script from "./DiscountNewCredentialsCardSingleOrJoint.vue?vue&type=script&lang=js&"
export * from "./DiscountNewCredentialsCardSingleOrJoint.vue?vue&type=script&lang=js&"
import style0 from "./DiscountNewCredentialsCardSingleOrJoint.vue?vue&type=style&index=0&id=35c70e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c70e04",
  null
  
)

export default component.exports